import { useContext } from "react";
import CartContext from "../../context/cart";

const PickUpAlreadyBooked = () => {
  const { labels, setCurrentSectionIndex, setHideMyBooking } = useContext(CartContext);

  return (
    <>
      <h2 className="carrello-content__title">
        {labels?.WELFARE_BOOKED_SLOT_TITLE || "Lo slot che hai richiesto non c'è più"}
      </h2>
      <div
        className="carrello-content__text"
        dangerouslySetInnerHTML={{
          __html:
            labels?.WELFARE_BOOKED_SLOT ||
            "<p>Ci dispiace ma <strong>lo slot che avevi richiesto è stato nel frattempo già occupato</strong>. Torna al calendario per scegliere un altro slot compatibile con le tue esigenze.</p>",
        }}
      />
      <button
        className="button primary"
        type="button"
        onClick={() => {
          setHideMyBooking(true);
          setCurrentSectionIndex(2);
        }}
      >
        {labels?.WELFARE_FORM_BTN_CHOOSE_ANOTHER_SLOT || "Choose another slot"}
      </button>
    </>
  );
};
export default PickUpAlreadyBooked;
